module.exports = __webpack_public_path__ + "media/images/country_flags/rw-2566f0eb23e28ac969eed5e27751cf6f.png";